const mobile = {
  data() {
    return {
      mobile: null,
      isActive: true,
      isLoaded: false,
      scrollWhenFullscreen: 0,
    };
  },
  created() {
    const moveMiniplayerToBody = () => {
      $('.miniplayer-wrap').appendTo('body');
    };
    const show = (shouldPlay = true) => {
      this.isActive = true;
      this.isLoaded = true;

      localStorage.removeItem('thisItemChecksIfMobileMiniplayerShouldBeHidden');
      localStorage.removeItem(
        'thisItemChecksUntilWhenMobileMiniplayerShouldBeHidden'
      );

      if (shouldPlay) {
        this.play();
      }
    };
    const hide = () => {
      this.isFullscreen = false;
      this.isActive = false;
      this.pause();

      localStorage.setItem(
        'thisItemChecksIfMobileMiniplayerShouldBeHidden',
        true
      );
      localStorage.setItem(
        'thisItemChecksUntilWhenMobileMiniplayerShouldBeHidden',
        Date.now() + 1000 * 60 * 60
      ); // 1 hour
    };
    const enableFullscreen = () => {
      this.scrollWhenFullscreen =
        window.pageYOffset || document.documentElement.scrollTop;
      $('body').addClass('-fake-fullscreen');
      this.isFullscreen = true;
    };
    const disableFullscreen = () => {
      $('body').removeClass('-fake-fullscreen');
      this.isFullscreen = false;
      window.scrollTo(0, this.scrollWhenFullscreen);
    };
    const goToFullscreen = () => {
      this.isFullscreen = true;
    };
    const leaveFullscreen = () => {
      this.isFullscreen = false;
    };

    this.mobile = {
      moveMiniplayerToBody,
      show,
      hide,
      enableFullscreen,
      disableFullscreen,
      goToFullscreen,
      leaveFullscreen,
    };
  },
};

export default mobile;
